<div class="ms-2" [ngClass]="{ 'mb-3': expanded, 'mb-0': !expanded }">
  <div
    class="d-flex justify-content-center align-items-center mt-4"
    [ngClass]="{ 'mb-4': expanded, 'mb-0': !expanded }"
  >
    <div
      *ngIf="header !== 'left'"
      class="border-top flex-grow-1 border-1"
    ></div>
    <h5
      class="p-0 m-0"
      [ngClass]="{
        'ms-0': header == 'left',
        'ms-4': header !== 'left',
        'me-0': header == 'right',
        'me-4': header !== 'right'
      }"
    >
      <i
        class="fas text-primary small"
        [ngClass]="{ 'fa-minus-circle': expanded, 'fa-plus-circle': !expanded }"
        (click)="onToggleExpanded()"
      ></i
      >&nbsp;
      <ng-content select="span.title"></ng-content>
    </h5>
    <div
      *ngIf="header !== 'right'"
      class="border-top flex-grow-1 border-1"
    ></div>
  </div>

  <div [style.display]="expanded ? 'block' : 'none'">
    <ng-content select="span.body"></ng-content>
  </div>
</div>
